<template>
  <div :class="['header',scroll>200?'':'']">
    <div class="container">
		<!-- <div class="founding">	
		</div> -->
      <div class="row">
        <div class="logo pull-left"></div>
        <div class="nav pull-right">
          <ul>
            <li
              class="pull-left"
              :class="[
                ,
                i.tags.includes(activeRoute) ? 'active' : '',
                `link-${index}`,
              ]"
              v-for="(i, index) in nav"
            >
              <a :class="['link']" @click="goUrl(i.path)">{{ i.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import {
	    debounce
	} from "@/utils/utils";
export default {
  name: "Header",
  data() {
    return {
      nav: [
        {
          name: "首页",
          path: "/",
          tags: ["home"],
        },
        {
          name: "研究成果",
          path: "/researchlist",
          tags: ["researchlist", "researchdetail"],
        },
        {
          name: "新闻活动",
          path: "/newslist",
          tags: ["newslist", "newsdetail"],
        },
        {
          name: "大事件",
          path: "/bignewslist",
          tags: ["bignewslist", "bignewsdetail"],
        },
        {
          name: "数据服务",
          path: "/DataServe",
          tags: [
            "dataserve",
            "datainsight",
            "collateral",
            "viewitems",
            "customization",
          ],
        },
        {
          name: "关于我们",
          path: "/about",
          tags: ["about"],
        },
        {
          name: "交易所",
          path: "/exchange",
          tags: ["exchange"],
        },
        {
          name: "中地会",
          path: "http://www.zhongdihui.com/zdh/index.html",
          tags: ["none"],
        },
      ],
      activeRoute: "home",
	  scroll:'',
	  reScroll:''
	  
    };
  },
  watch: {
    //监听路由变化改变导航颜色
    $route(to, from) {
      if(to.name){
        this.activeRoute = to.name.toLowerCase();
      }
    },
  },
  mounted() {
      //监听滚动事件
      //debounce为防抖，延迟为100毫秒
      window.addEventListener("scroll", this.menu);
  },
  methods: {
    //路由跳转
    goUrl(path) {
      if (path !== this.$route.path && path.search("http") == -1) {
        this.$router.push(path);
      } else if (path.search("http") != -1) {
        window.open(path);
      }
    },
	//滚动事件
	menu() {
	    //页面滚动的距离
	    this.scroll =
	        document.documentElement.scrollTop || document.body.scrollTop;
	    //页面滚动后剩下的距离
	    this.reScroll = document.body.scrollHeight - this.scroll;	
			
		if(this.scroll>200){
			this.$parent.$el.style.top = '12px'		
		}else{
			this.$parent.$el.style.top = '120px'	
		}
	},
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.header {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: whitesmoke;
  z-index: 999;
  box-shadow: 0px 0px 20px 5px rgba(0, 0, 0, 0.2);
  &.active{
	  position: fixed;
	  top: -200px;
  }
  .founding{
	  height: 200px;
	  background-image: url(../assets/img/founding.jpeg);
	  background-repeat: no-repeat;
	  background-size: cover;
	  background-position: top center;
  }

  .logo {
    background-image: url("../assets/img/logo.png");
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
    width: 195px;
    height: 47px;
    position: relative;
    transform: translate(0px, 40px);
  }

  .nav {
    li {
      list-style: none;
      height: 120px;
      width: 120px;
      line-height: 120px;
      text-align: center;
      box-sizing: content-box;

      a {
        @include default-text;
        display: inline-block;
        font-size: 18px;
        color: #666666;
        cursor: pointer;
      }
      &.link-6 {
        a {
          border-right: 1px solid #666666;
          padding-right: 20px;
          height: 38px;
          line-height: 38px;
          font-size: 18px;
          color: #263e8c;
          font-weight: 900;
        }
        text-align: right;
      }
      &.link-7 {
        a {
          font-size: 18px;
          color: #263e8c;
          font-weight: 900;


        }
        text-align: left;
        padding-left: 20px;
      }
    }
    .active {
      a {
        color: white;
      }
      background-color: #263e8c;
      &.link-6 {
        background-color: transparent;
        a {
          color: #263e8c;

        }
      }
    }
  }
}
</style>
